/* projects/signature-it/ngx-generic/components/social-share/social-share.component.scss */
.no-text ::ng-deep .sb-wrapper {
  background: transparent;
  border: none;
}
.no-text ::ng-deep .sb-wrapper .sb-content {
  width: 40px;
  height: 40px;
  background-size: auto;
  background-position: center center;
  background-repeat: no-repeat;
  border-radius: 50%;
  border: 1px solid rgba(112, 112, 112, 0.3019607843);
}
::ng-deep .mat-mdc-menu-panel {
  border: 2px solid #dbe2f1;
  border-radius: 20px !important;
  margin-top: 8px;
}
::ng-deep .mat-mdc-menu-panel ::ng-deep .sb-wrapper {
  border: none;
  background: transparent;
  font-size: inherit !important;
  margin: 0;
}
::ng-deep .mat-mdc-menu-panel ::ng-deep .sb-wrapper .sb-content {
  padding-left: 40px;
  background-repeat: no-repeat;
  background-position-y: center;
  background-position-x: left;
}
::ng-deep .mat-mdc-menu-panel ::ng-deep .sb-wrapper .sb-content .sb-text {
  text-align: initial;
}
::ng-deep .mat-mdc-menu-panel.social-wrapper {
  margin-top: 8px;
}
::ng-deep [dir=rtl] .sb-wrapper .sb-content {
  padding-left: 0;
  padding-right: 40px;
  background-position-x: right;
}
.facebook-share-btn ::ng-deep .sb-content {
  background-image: url(/assets/images/fb_icon.svg);
}
.twitter-share-btn ::ng-deep .sb-content {
  background-image: url(/assets/images/twitter_icon.svg);
}
.whatsapp-share-btn ::ng-deep .sb-content {
  background-image: url(/assets/images/whatsapp_icon.svg);
}
.email-share-btn ::ng-deep .sb-content {
  background-image: url(/assets/images/mail_icon.svg);
}
.copy-share-btn ::ng-deep .sb-content {
  background-image: url(/assets/images/copy_icon.svg);
}
/*# sourceMappingURL=social-share.component.css.map */
